import React from 'react';
import PropTypes from 'prop-types';
import { Droppable as DNDDroppable } from 'react-beautiful-dnd';

const Droppable = ({ children, droppableId, type, className, style, draggingColor }) => {
  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? draggingColor.withDragging : draggingColor.withoutDragging,
    display: 'inline-block',
    ...style
  });

  return (
    <DNDDroppable
      droppableId={ droppableId }
      type={ type }
    >
      {
        (provided, snapshot) => (
          <div
            ref={ provided.innerRef }
            className={ className }
            style={ getListStyle(snapshot.isDraggingOver) }
          >
            { children }
            { provided.placeholder }
          </div>
        )
      }
    </DNDDroppable>
  );
};

Droppable.defaultProps = {
  type: 'DEFAULT',
  className: '',
  style: {},
  draggingColor: {
    withDragging: '#f3f3f3',
    withoutDragging: '#ffffff'
  }
};

Droppable.propTypes = {
  children: PropTypes.array.isRequired,
  droppableId: PropTypes.string.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  draggingColor: PropTypes.shape({
    withDragging: PropTypes.string,
    withoutDragging: PropTypes.string
  })
};

export default Droppable;



// WEBPACK FOOTER //
// ./src/shared/components/dragAndDropBeautiful/droppable/Droppable.js